import { useEffect, useState, useMemo } from "react";

export function useWindowSize() {
	const [windowSize, setWindowSize] = useState({
		width: 0,
		height: 0
	});

	useEffect(() => {
		if (typeof window !== "undefined") {
			const handleResize = () => {
				setWindowSize({
					width: window.innerWidth,
					height: window.innerHeight
				});
			};
			window.addEventListener("resize", handleResize);
			handleResize();
			return () => window.removeEventListener("resize", handleResize);
		}
	}, []);
	return windowSize;
}

export function useNetworkStatus() {
	const [isOnline, setIsOnline] = useState(false);

	useEffect(() => {
		const interval = setInterval(() => {
			fetch("https://www.google.com/", {
				mode: "no-cors"
			})
				.then(() => !isOnline && setIsOnline(true))
				.catch(() => isOnline && setIsOnline(false));
		}, 5000);

		return () => clearInterval(interval);
	}, [isOnline]);

	return { isOnline };
}

export function useIsInViewport(ref) {
	const [isIntersecting, setIsIntersecting] = useState(false);

	const observer = useMemo(
		() =>
			new IntersectionObserver(([entry]) =>
				setIsIntersecting(entry.isIntersecting)
			),
		[]
	);

	useEffect(() => {
		observer.observe(ref.current);
		return () => {
			observer.disconnect();
		};
	}, [ref, observer]);
	return isIntersecting;
}
